import React from 'react';
import { useStore } from '../utils/store';
import { Token } from '../types';

interface TokenSelectionProps {
  token: Token;
  isCompact: boolean;
}

const TokenSelection: React.FC<TokenSelectionProps> = ({ token, isCompact }) => {
  const { selectedTokenIds, toggleTokenSelection } = useStore();
  
  const isSelected = selectedTokenIds.includes(token.id);
  
  const handleToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    toggleTokenSelection(token.id);
  };
  
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };
  
  return (
    <td className={`px-3 ${isCompact ? 'py-1' : 'py-3'} whitespace-nowrap text-sm text-gray-500 relative`}>
      <div className="flex items-center justify-center">
        <input
          type="checkbox"
          className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
          checked={isSelected}
          onChange={handleToggle}
          onClick={handleClick}
        />
      </div>
    </td>
  );
};

export default TokenSelection; 